import { useMentiSpring } from '@mentimeter/motion/spring';
import { animated, easings } from '@react-spring/web';

interface CorrectAreaOverlayProps {
  width: number;
  height: number;
  x: number;
  y: number;
  correctAreaWidth: number;
  correctAreaHeight: number;
  isVisible: boolean;
  disableAnimations: boolean;
}

export const CorrectAreaOverlay = ({
  width,
  height,
  x,
  y,
  correctAreaWidth,
  correctAreaHeight,
  isVisible,
  disableAnimations,
}: CorrectAreaOverlayProps) => {
  const [springs] = useMentiSpring({
    from: {
      fill: `rgba(34, 34, 34, ${isVisible ? 0.6 : 0})`,
      strokeOpacity: isVisible ? 1 : 0,
    },
    to: {
      fill: `rgba(34, 34, 34, ${isVisible ? 0.6 : 0})`,
      strokeOpacity: isVisible ? 1 : 0,
    },
    config: { duration: 300, easing: easings.easeInOutQuart },
    immediate: disableAnimations,
  });

  return (
    <g>
      <defs>
        <mask id="correctAreaMask">
          <rect x={0} y={0} width={width} height={height} fill="white" />
          <rect
            x={x}
            y={y}
            width={correctAreaWidth}
            height={correctAreaHeight}
            fill="black"
          />
        </mask>
      </defs>

      {/* Gray overlay with correct area cut out */}
      <animated.rect
        x={0}
        y={0}
        width={width}
        height={height}
        fill={springs.fill}
        mask="url(#correctAreaMask)"
        style={{ mixBlendMode: 'multiply' }}
      />

      {/* Visible rectangle border for the correct area */}
      <animated.rect
        x={x}
        y={y}
        width={correctAreaWidth}
        height={correctAreaHeight}
        fill="transparent"
        stroke="white"
        strokeWidth="2"
        strokeOpacity={springs.strokeOpacity}
      />
    </g>
  );
};
